module.exports = __webpack_public_path__ + "02_bob_brown.cc922419.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_bob_brown.png
// module id = N1An
// module chunks = 0